import React from "react";
import { datadogRum } from "@datadog/browser-rum";

interface DDErrorBoundaryProps {
  children: React.ReactNode;
}

export class DDErrorBoundary extends React.Component<DDErrorBoundaryProps> {
  constructor(props: DDErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const renderingError = new Error(error.message);
    renderingError.name = "ReactRenderingError";
    renderingError.stack = errorInfo.componentStack || "";
    renderingError.cause = error;

    datadogRum.addError(renderingError);
  }

  render() {
    return this.props.children;
  }
}
